import { Observable } from 'rxjs';
import { ClinicCabinet, DataSourceResponse } from '../../models';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { HttpParamsEncoder } from '../../tools';

@Injectable({ providedIn: 'root' })
export class ClinicCabinetService extends ApiService {
  endPoint = '/api/clinicCabinets';
  create(model: ClinicCabinet) {
    return this.http.post(`${this.clinicsBaseURL}${this.endPoint}`, model);
  }

  update(id: string, model: ClinicCabinet) {
    return this.http.put(`${this.clinicsBaseURL}${this.endPoint}/${id}`, model);
  }

  delete(id: string) {
    return this.http.delete<any>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
  }
  deleteRange(ids: string[]) {
    return this.http.post<any>(`${this.clinicsBaseURL}${this.endPoint}/deleteRange`, ids);
  }

  get(id: string): Observable<ClinicCabinet> {
    return this.http.get<ClinicCabinet>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
  }

  getList(queryParams: any): Observable<DataSourceResponse<ClinicCabinet>> {
    const params = new HttpParamsEncoder().encode(queryParams);
    return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}`, { params });
  }

  getAll(queryParams: any): Observable<ClinicCabinet[]> {
    const params = new HttpParamsEncoder().encode(queryParams);
    return this.http.get<ClinicCabinet[]>(`${this.clinicsBaseURL}${this.endPoint}/all`, { params });
  }

  getAllSchedule(queryParams: any): Observable<ClinicCabinet[]> {
    const params = new HttpParamsEncoder().encode(queryParams);
    return this.http.get<ClinicCabinet[]>(`${this.clinicsBaseURL}${this.endPoint}/all-schedule`, { params });
  }

  getClinicSchedules(queryParams: any): Observable<ClinicCabinet[]> {
    const params = new HttpParamsEncoder().encode(queryParams);
    return this.http.get<ClinicCabinet[]>(`${this.clinicsBaseURL}${this.endPoint}/clinic-schedules`, { params });
  }

  getClinicOperationSchedules(queryParams: any): Observable<ClinicCabinet[]> {
    const params = new HttpParamsEncoder().encode(queryParams);
    return this.http.get<ClinicCabinet[]>(`${this.clinicsBaseURL}${this.endPoint}/clinic-operation-schedules`, { params });
  }

  getClinicCabinetSchedules(queryParams: any): Observable<ClinicCabinet[]> {
    const params = new HttpParamsEncoder().encode(queryParams);
    return this.http.get<ClinicCabinet[]>(`${this.clinicsBaseURL}${this.endPoint}/clinic-cabinet-schedules`, { params });
  }
}
